import { areas } from "./areas";
import { characters } from "./characters";
import { events } from "./events";
import { hudMessages } from "./hudMessages";
import { itemNames } from "./itemNames";
import { misc } from "./misc";
import { popups } from "./popups";
import { signs } from "./signs";
import { stats } from "./stats";
import { thingNames } from "./thingNames";
import { tutorial } from "./tutorial";
import { ui } from "./ui";
import { weaponNames } from "./weaponNames";

export const allEnStrings: Record<string, string> = {
	...areas,
	...characters,
	...events,
	...hudMessages,
	...itemNames,
	...misc,
	...popups,
	...signs,
	...stats,
	...thingNames,
	...tutorial,
	...ui,
	...weaponNames,
};
